// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__xTsCK","footer":"ChangeClinic_footer__1O9Vw"};